import {
  Component, inject,
  input, signal
} from '@angular/core';
import { removeBackground } from '@imgly/background-removal';
import { ImagePickerComponent } from 'src/app/common/image-picker/image-picker.component';
import { User } from 'src/app/interfaces/user';
import { ToastService } from 'src/app/services/Toast/toast.service';

@Component({
  selector: 'tsm-details',
  imports: [ImagePickerComponent],
  templateUrl: './tsm-details.component.html',
  styleUrl: './tsm-details.component.scss',
})
export class TSMDetails {
  // injectables
  toast = inject(ToastService);

  // inputs
  editing = input.required<boolean>();
  user = input.required<User>();

  // states
  isProcessing = signal<boolean>(false);

  // data
  e_signature = signal<Blob | string | undefined>(undefined);
  image = signal<string>('');

  constructor() { }

  ngOnInit() {
    this.loadValues();
  }

  loadValues() {
    this.image.set(this.user().e_signature || '');
  }

  // utils
  onFileChange(file: File) {
    this.isProcessing.set(true);
    this.image.set(URL.createObjectURL(file));

    removeBackground(file, {
      output: {
        format: 'image/png',
      },
      device: 'gpu',
    })
      .then((blob) => {
        // replace with the final image
        this.e_signature.set(blob);
        this.image.set(URL.createObjectURL(blob));
      })
      .catch((err) => {
        this.toast.makeToast(
          'error',
          "There's a problem processing your image!",
          3000,
        );
      })
      .finally(() => this.isProcessing.set(false));
  }
}
